export const getSidebarRoute = async (brandConfigState, brandModuleSetting, webModuleSetting, hideChildren = false, checkUserAccessRight) => {

    let webNavigation = []
    let moduleName = []
    let moreModule = []
    webModuleSetting &&
    (await Promise.all(
        [...webModuleSetting] // Create a shallow copy of the array
            .sort((a, b) => a.position - b.position) // Sort the copied array based on position in ascending order
            .map(async (item) => {
                const {
                    path,
                    sub,
                    type,
                    icon,
                    accessRightID
                } = getSettings(item?.moduleId?.name, brandConfigState, brandModuleSetting)

                if (item?.moduleId?.isEnabled === true) {
                    moduleName.push(item?.moduleId?.name)

                    const enabledSub = sub
                        ?.map((d) => {
                            const isEnabled = brandModuleSetting?.find((setting) => setting?.name === d?.key)?.isEnabled
                            const hasAccess = d?.subAccessRightID ? checkUserAccessRight(d?.subAccessRightID) : true

                            if (isEnabled) return {
                                ...d,
                                locked: !hasAccess
                            }
                            else return null
                        })
                        ?.filter((d) => !moduleName?.includes(d?.key) && d)

                    const hasAccess = accessRightID ? checkUserAccessRight(accessRightID) : true
                    const isParent = enabledSub && enabledSub.length > 0

                    if (!isParent || hasAccess) {
                        webNavigation.push({
                            key: item?.moduleId?.name,
                            label: item?.moduleId?.name,
                            path: path,
                            sub: enabledSub,
                            type: type,
                            icon: icon,
                            accessRightID: accessRightID,
                            categoryName: item?.categoryName,
                            locked: !hasAccess
                        })
                    }
                }
            })
    ))

    let moduleEnabledSetting = await brandModuleSetting?.filter((item) => !moduleName?.includes(item?.name) && item?.isEnabled === true)

    const formattedModuleEnabledSetting = hideChildren ? moduleEnabledSetting?.filter((item) => !item?.parent) : moduleEnabledSetting

    formattedModuleEnabledSetting &&
    (await Promise.all(
        formattedModuleEnabledSetting?.map(async (item) => {
            const {path, sub, type, icon, accessRightID} = getSettings(item?.name, brandConfigState, brandModuleSetting)
            moduleName.push(item?.moduleId?.name)

            const enabledSub = sub
                ?.map((d) => {
                    const isEnabled = brandModuleSetting?.find((setting) => setting?.name === d?.key)?.isEnabled
                    const hasAccess = d?.subAccessRightID ? checkUserAccessRight(d?.subAccessRightID) : true
                    if (isEnabled) return {
                        ...d,
                        locked: !hasAccess
                    }
                    else return null
                })
                ?.filter((d) => !moduleName?.includes(d?.key) && d)

            const hasAccess = accessRightID ? checkUserAccessRight(accessRightID) : true
            const isParent = enabledSub && enabledSub.length > 0

            if (!isParent || hasAccess) {
                moreModule.push({
                    key: item?.name,
                    label: item?.name,
                    path: path,
                    sub: enabledSub,
                    type: type,
                    icon: icon,
                    accessRightID: accessRightID,
                    categoryName: item?.categoryName,
                    locked: !hasAccess
                })
            }
        })
    ))

    webNavigation = [
        {
            key: "home",
            label: "Home",
            path: "/dashboard",
        },
        ...webNavigation,
        {
            key: "more",
            label: "More",
            sub: moreModule,
        },
    ]

    return webNavigation
}

export function getSettings(name, brandConfigState, brandModuleSetting) {
    let path
    let type
    let sub
    let categoryName
    let accessRightID = null
    const cmsUrl = localStorage?.getItem("cmsUrl")
    const arenaURL = localStorage?.getItem("arenaURL")
    const userToken = localStorage?.getItem("a_t")

    switch (name) {
        case "LIVE Broadcast":
            path = "/live-broadcast"
            accessRightID = "live-broadcast"
            break
        case "Newsletter":
            path = "https://www." + cmsUrl + "/newsletters"
            type = "_blank"
            accessRightID = "newsletter"
            break
        case "Education":
            path = "https://www." + cmsUrl + "/educational"
            type = "_blank"
            accessRightID = "education"
            break
        case "Trade Ideas":
            path = "/trade-ideas"
            accessRightID = "trade-ideas"
            break
        case "A.I Technical Screener":
            path = "/ai-technical-screener"
            accessRightID = "ai-technical-screener"
            break
        case "Smart Score":
            path = "/smart-score"
            accessRightID = "smart-score"
            break
        case "Market News":
            path = "/market-news"
            accessRightID = "market-news"
            break
        case "Economic Calendar":
            path = "/economic-calendar"
            accessRightID = "economic-calendar"
            break
        case "Profile":
            path = "/profile"
            break

        case "Verification":
            path = "/account-verification"
            break

        case "Referral":
            path = "/referral"
            accessRightID = "referral"
            break

        case "Wallet Operations":
            path = "/wallet-operations"
            break

        case "Deposit":
            path = "/wallet-deposit"
            accessRightID = "ewallet-deposit"
            break

        case "Withdrawal":
            path = "/wallet-withdrawal"
            accessRightID = "ewallet-withdrawal"
            break

        case "Wallet Exchange":
            path = "/wallet-exchange"
            accessRightID = "ewallet-exchange"
            break

        case "Client Deposits/Withdrawals":
            path = "/client-deposits-withdrawals"
            accessRightID = "reports"
            break
        case "Client Trades":
            path = "/client-trades"
            accessRightID = "reports"
            break
        case "Client Trading Accounts":
            path = "/client-trading-accounts"
            accessRightID = "reports"
            break
        case "Client Listing":
            path = "/client-listing"
            accessRightID = "reports"
            break
        case "Commissions":
            path = "/commissions"
            accessRightID = "reports"
            break
        case "Volume Commission":
            path = "/volume-commission"
            accessRightID = "reports"
            break
        case "Spread Earnings Commission":
            path = "/spread-earnings-commission"
            accessRightID = "reports"
            break
        case "Profit Sharing Commission":
            path = "/profit-sharing-commission"
            accessRightID = "reports"
            break

        case "Wallet":
            sub = brandModuleSetting && brandModuleSetting
                ?.filter((item) => item?.parent?.name === name && item?.isEnabled === true)
                ?.map((subItem) => {
                    let subPath
                    let subType
                    let subAccessRightID = null
                    switch (subItem.name) {
                        case "Wallet Operations":
                            subPath = "/wallet-operations"
                            break
                        case "Withdrawal":
                            subPath = "/wallet-withdrawal"
                            subAccessRightID = "ewallet-withdrawal"
                            break
                        case "Deposit":
                            subPath = "/wallet-deposit"
                            subAccessRightID = "ewallet-deposit"
                            break
                    }
                    return {
                        key: subItem.name,
                        label: subItem.name,
                        path: subPath,
                        type: subType,
                        subAccessRightID: subAccessRightID,
                        categoryName: subItem.categoryName,
                    }
                })
            break

        case "Loyalty Program":
            path = "/loyalty-program"
            break

        case "Self-Trade":
            path = "/self-trade"
            break

        case "Analysis":
            sub = brandModuleSetting
                ?.filter((item) => item?.parent?.name === name && item?.isEnabled === true)
                .map((subItem) => {
                    let subPath
                    let subType
                    let subAccessRightID = null
                    switch (subItem.name) {
                        case "LIVE Broadcast":
                            subPath = "/live-broadcast"
                            subAccessRightID = "live-broadcast"
                            break
                        case "Newsletter":
                            subPath = "https://www." + cmsUrl + "/newsletters"
                            subType = "_blank"
                            subAccessRightID = "newsletter"
                            break
                        case "Education":
                            subPath = "https://www." + cmsUrl + "/educational"
                            subType = "_blank"
                            subAccessRightID = "education"
                            break
                        case "Trade Ideas":
                            subPath = "/trade-ideas"
                            subAccessRightID = "trade-ideas"
                            break
                        case "A.I Technical Screener":
                            subPath = "/ai-technical-screener"
                            subAccessRightID = "ai-technical-screener"
                            break
                        case "Smart Score":
                            subPath = "/smart-score"
                            subAccessRightID = "smart-score"
                            break
                        case "Market News":
                            subPath = "/market-news"
                            subAccessRightID = "market-news"
                            break
                        case "Economic Calendar":
                            subPath = "/economic-calendar"
                            subAccessRightID = "economic-calendar"
                            break
                        case "Market Buzz":
                            subPath = "/market-buzz"
                            subAccessRightID = "market-buzz"
                            break
                        case "Strategy Builder":
                            subPath = "/strategy-builder"
                            subAccessRightID = "strategy-builder"
                            break
                    }
                    return {
                        key: subItem.name,
                        label: subItem.name,
                        path: subPath,
                        type: subType,
                        subAccessRightID: subAccessRightID,
                        categoryName: subItem.categoryName,
                    }
                })
            break

        case "Markets":
            sub = brandModuleSetting
                ?.filter((item) => item?.parent?.name === name && item?.isEnabled === true)
                .map((subItem) => {
                    let subPath
                    let subType
                    switch (subItem.name) {
                        case "Quotes":
                            subPath = "/quotes"
                            break
                        case "Charts":
                            subPath = "/charts"
                            break
                        case "Trade":
                            subPath = "/trade"
                            break
                    }
                    return {
                        key: subItem.name,
                        label: subItem.name,
                        path: subPath,
                        type: subType,
                        categoryName: subItem.categoryName,
                    }
                })
            break

        case "Reports":
            sub = brandModuleSetting
                .filter((item) => item?.parent?.name === name && item?.isEnabled === true)
                .map((subItem) => {
                    let subPath
                    let subType
                    switch (subItem.name) {
                        case "Client Deposits/Withdrawals":
                            subPath = "/client-deposits-withdrawals"
                            break
                        case "Client Trades":
                            subPath = "/client-trades"
                            break
                        case "Client Trading Accounts":
                            subPath = "/client-trading-accounts"
                            break
                        case "Client Listing":
                            subPath = "/client-listing"
                            break
                        case "Commissions":
                            subPath = "/commissions"
                            break
                        case "Volume Commission":
                            subPath = "/volume-commission"
                            break
                        case "Spread Earnings Commission":
                            subPath = "/spread-earnings-commission"
                            break
                        case "Profit Sharing Commission":
                            path = "/profit-sharing-commission"
                            break
                    }
                    return {
                        key: subItem.name,
                        label: subItem.name,
                        path: subPath,
                        type: subType,
                        categoryName: subItem.categoryName,
                    }
                })
            accessRightID = "reports"
            break

        case "FAQ":
            path = "/faq"
            break

        case "Trading Account":
            path = "/trading-account"
            break

        case "Community":
            path = "/community"
            break

        case "Promotions":
            path = "https://" + cmsUrl + "/promotion"
            type = "_blank"
            accessRightID = "promotion"
            break

        case "Support":
            path = "/support"
            break

        case "Arena":
            path = "https://" + arenaURL + `/#/?token=${localStorage.getItem("a_t")}&theme=${localStorage.getItem("color")}`
            type = "_blank"
            accessRightID = "arena"
            break

        case "Activities":
            sub = brandModuleSetting
                ?.filter((item) => item?.parent?.name === name && item?.isEnabled === true)
                .map((subItem) => {
                    let subPath
                    let subType
                    switch (subItem.name) {
                        case "Promo Materials":
                            subPath = "/promo-materials"
                            break
                    }
                    return {
                        key: subItem.name,
                        label: subItem.name,
                        path: subPath,
                        type: subType,
                        categoryName: subItem.categoryName,
                    }
                })
            break

        case "Mission":
            path = "https://" + arenaURL + "/#/missions" + "?token=" + userToken
            type = "_blank"
            break

        case "Promo Materials":
            path = "/promo-materials"
            break

        case "Reward":
            // sub = brandModuleSetting
            //     ?.filter((item) => item?.parent?.name === name && item?.isEnabled === true)
            //     .map((subItem) => {
            //         let subPath
            //         let subType
            //         switch (subItem.name) {
            //             case "Voucher":
            //                 subPath = "/reward"
            //                 break
            //         }
            //         return {
            //             key: subItem.name,
            //             label: subItem.name,
            //             path: subPath,
            //             type: subType,
            //             categoryName: subItem.categoryName,
            //         }
            //     })
            path = "https://" + arenaURL + "/#/rewards" + "?token=" + userToken
            type = "_blank"
            break

        case "Liquidity Pool":
            path = "/liquidity-pool"
            break

        case "MAM/PAMM":
            path = "/mam-pamm"
            break

        case "Copy Trade":
            path = "/copy-trade"
            break
        case "Market Buzz":
            path = "/market-buzz"
            accessRightID = "market-buzz"
            break
        case "AI Bot Strategy":
            path = "/ai-bot-strategy"
            accessRightID = "ai-bot-strategy"
            break
        case "Strategy Builder":
            path = "/strategy-builder"
            accessRightID = "strategy-builder"
            break
    }

    return {
        path: path,
        sub: sub,
        type: type,
        accessRightID: accessRightID,
        categoryName: categoryName,
    }
}

export default getSidebarRoute;
